import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_SelectDisaster',
  name: 'CDS_VF_SelectDisaster',
  component: App,
  meta: {
    pageProperty: {
      title: '災害選択',
      controller: 'CDS_CTR_SelectDisaster',
    },
    guardRules: [user],
  },
};
